export default [
  {
    path: '/transaksi',
    name: 'transaksi',
    component: () => import('@/views/transaksi/Index.vue'),
    meta: {
      pageTitle: 'Transaksi ',
      requiresAuth: true,
      breadcrumb: [
        {
          text: 'Transaksi',
          active: true,
        },
      ],
    },
  },
  {
    path: '/transaksi-v2',
    name: 'transaksi-v2',
    component: () => import('@/views/transaksi-v2/Index.vue'),
    meta: {
      pageTitle: 'Transaksi V2',
      requiresAuth: true,
      breadcrumb: [
        {
          text: 'Transaksi',
          active: true,
        },
      ],
    },
  },
];
